const tabsList = document.querySelector(".tabs-list");
const tabsButtons = document.querySelectorAll(".tabs-button");
const tabsContents = document.querySelectorAll(".tab-content");

if (tabsList) {
	tabsList.addEventListener("click", e => {
		const tabToActivate = e.target.closest(".tabs-button");

		if (!tabToActivate || tabToActivate.classList.contains("active")) return;

		const targetId = tabToActivate.dataset.target;

		tabsButtons.forEach(btn => btn.classList.remove("active"));
		tabsContents.forEach(content => content.classList.remove("visible"));

		tabToActivate.classList.add("active");
		const targetContent = document.getElementById(targetId);

		if (targetContent) {
			targetContent.classList.add("visible");
		}
	});
}
